<template>
  <div class="tourists-kid-age">
    <div class="kid-age-info">
      <label>{{index+1}}й ребенок</label>
      <div class="btn-like-select" @click="change_state">{{humanize_age(localAge)}}</div>
    </div>
    <transition name="hide-1">

      <kid-age-selector v-if="want_change" :age="localAge" :min="min_age" @change="on_change_age"/>
    </transition>
  </div>
</template>

<script>
  import KidAgeSelector from "./KidAgeSelector";
  export default {
    components: { KidAgeSelector },
    props:['age', 'index', 'min_age'],
    data() {
      return{
        localAge: this.age === undefined ? 'Возраст' : this.age,
        want_change: false,
        key_id: `tourists-kid-age-${this.index}`,
      }
    },
    methods:{
      change_state(){
        this.$set(this,'want_change', !this.want_change);
      },
      on_change_age(age){
        // console.log('TouristsKidAge::on_change_age');
        this.$set(this, 'localAge', age);
        this.$set(this,'want_change', false);
        this.$emit('change', this.index, age);
      },
      humanize_age(age){
        if (age == 'Возраст') {
          return 'Возраст';
        } else if (age == 0) {
          return 'до 1 года';
        } else if (age == 1) {
          return '1 год';
        } else if ((age > 1) && (age < 5)) {
          return `${age} года`;
        } else {
          return `${age} лет`;
        }
      },

    }
  }
</script>
<style>
  .hide-1-enter-active, .hide-1-leave-active {
    transition: opacity .4s, height .2s;
    height: 168px;
  }
  .hide-1-enter, .hide-1-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    height: 0;
  }
</style>
